// @flow

import React from 'react'

export type PropTypes = {
  id: string,
  name: string,
  imageUrl: string,
  checked: boolean,
  onClick: Function,
}

export default (props: PropTypes) => (
  <div className="col-md-4">
    <div className="dashboad-favorite__popup-select-box">
      <input
        type="checkbox"
        id={`favorite_item_${props.id}`}
        checked={props.checked}
        readOnly
        className="dashboad-favorite__checkbox"
      />
      <label
        htmlFor={`favorite_item_${props.id}`}
        className="dashboad-favorite__checkbox"
        onClick={props.onClick}
      >
        <div className="dashboad-favorite__popup-select-box-img sm-hide">
          <img
            src={props.imageUrl}
            className="dashboad-favorite__popup-select-box-img-space"
            alt={props.name}
          />
        </div>
        <div className="dashboad-favorite__popup-select-box-text">
          <h3 className="dashboad-favorite__popup-select-box-text-title">
            {props.name}
          </h3>
          <p className="dashboad-favorite__popup-select-box-text-check sm-hide">
            <i className="fa fa-check" />
          </p>
        </div>
      </label>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/molecules/FavoriteListItem/index.jsx